import { useState } from "react";
import { User } from "../types/user";
import { ChevronDown, ChevronLeft, ChevronRight } from "lucide-react";

export default function UsersTable({ users, setSelectedUser }: { users: User[]; setSelectedUser: (user: User) => void }) {
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 10;

    const totalPages = Math.ceil(users.length / pageSize);

    const paginatedUsers = users.slice(
        (currentPage - 1) * pageSize,
        currentPage * pageSize
    );

    return (
        <div className="w-full">
            <div className="w-full bg-card rounded-xl p-4">
                <table className="w-full">
                    <thead className="border-b border-gray-400 text-xs text-gray-200">
                        <tr className="my-4">
                            <th className="text-center font-light py-2">User</th>
                            <th className="text-center font-light py-2">Email</th>
                            <th className="text-center font-light py-2">Phone Number</th>
                            <th className="text-center font-light py-2">Registration Date</th>
                            <th className="text-center font-light py-2">Location</th>
                            <th className="text-center font-light py-2">Service</th>
                            <th className="text-center font-light py-2">Status</th>
                            <th className="text-center font-light py-2">Action</th>
                        </tr>
                    </thead>

                    <tbody className="text-white text-xs">
                        {paginatedUsers.map((user, index) => (
                            <tr
                                key={index}
                                className={index % 2 === 0 ? "bg-card/50" : "bg-card/30"}
                            >
                                <td className="text-center py-2">{user.name}</td>
                                <td className="text-center py-2">{user.email}</td>
                                <td className="text-center py-2">{user.phone}</td>
                                <td className="text-center py-2">{user.createdAt}</td>
                                <td className="text-center py-2">{user.country}</td>
                                <td className="text-center py-2">{user.service_name}</td>
                                <td className="text-center py-2 text-green-500">Active</td>
                                <td className="text-center py-2">
                                    <button className="bg-none border border-white text-white rounded-lg py-1 px-3 hover:scale-105 cursor-pointer"
                                        onClick={() => setSelectedUser(user)}
                                    >
                                        Modify
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {/* Pagination Controls */}
            <div className="flex justify-between items-center mt-4 text-xs text-white">
                <div className="bg-card flex items-center gap-x-2 text-white text-xs py-1 px-3 rounded-md">
                    <p>Rows per page:</p>
                    <p>10</p>
                    <ChevronDown size={16} />
                </div>
                <div className="flex items-center gap-x-2 bg-card rounded-md">
                    <button
                        onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                        disabled={currentPage === 1}
                        className="px-3 py-1 rounded disabled:opacity-50"
                    >
                        <ChevronLeft />
                    </button>

                    <span>
                        {currentPage} / {totalPages}
                    </span>

                    <button
                        onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
                        disabled={currentPage === totalPages}
                        className="px-3 py-1 rounded disabled:opacity-50"
                    >
                        <ChevronRight />
                    </button>
                </div>
            </div>
        </div>
    );
}
